import { api } from "apiServer"
import { Layout } from "components/common"
import CardLive from "components/CardLive"
import CardVod from "components/CardVod"
import { Fragment, useEffect, useRef, useState } from "react"
import CardLiveShow from "components/CardLiveShow"
import TypeEvent from "utils/TypeEvent"
import CardBanner from "components/CardBanner"
import CardCategory from "components/CardCategory"
import CardStory from "components/CardStory"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import CardChannel from "components/CardChannel"
import { trackGA } from "lib/func"
import config from "lib/config"
import { getPropsSlugPage } from "lib/dataStore"
import { getCookieValue } from "lib/func"
import CardShort from "components/CardShort"

let calling = false

function getClass(type_block, display_type) {
  switch (type_block) {
    case TypeEvent.LIVE:
      return "mb-8 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6"
    case TypeEvent.LIVESHOW: {
      if (DisplayTypeScreenBlock.HORIZONTAL === display_type) {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6"
      } else {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-6"
      }
    }
    case TypeEvent.VOD: {
      if (DisplayTypeScreenBlock.HORIZONTAL === display_type) {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6"
      } else {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-6"
      }
    }
    case TypeEvent.BANNER: {
      if (DisplayTypeScreenBlock.HORIZONTAL === display_type) {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6"
      } else {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-6"
      }
    }
    case TypeEvent.CATEGORY: {
      if (DisplayTypeScreenBlock.HORIZONTAL === display_type) {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-6"
      } else {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-6"
      }
    }
    case TypeEvent.SHORT: {
      return "mb-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 2xl:grid-cols-6 gap-6"
    }
    case TypeEvent.STORY:
      return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-6"
    case TypeEvent.CHANNEL: {
      if (DisplayTypeScreenBlock.HORIZONTAL === display_type) {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6"
      } else {
        return "mb-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5 gap-6"
      }
    }
  }
}
function Component({ lists, slug, video }) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState(lists)
  const [_slug, setSlug] = useState(slug)
  const [_video, setVideo] = useState(video)
  const pageNum = useRef(1)
  const maxCount = useRef(50)
  const [lastFetchTime, setLastFetchTime] = useState(Date.now())

  useEffect(() => {
    function onScroll() {
      if (window.scrollY + window.innerHeight > (document.body.scrollHeight * 6) / 7) {
        if (!calling) {
          setLoading(true)
        }
      }
    }

    window.addEventListener("scroll", onScroll)
    trackGA(name, "BLOCK")
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  const fetchData = async () => {
    try {
      const timestamp = Date.now()

      const accessToken = getCookieValue("accessToken")

      const { data, block } = await api.getFullByBlock(accessToken, _slug, {
        page_num: 1,
        page_size: 24
      })
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
      setRows(data)
      setVideo(block)
      setLastFetchTime(timestamp)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchMoreData() {
    const accessToken = getCookieValue("accessToken")

    try {
      pageNum.current = pageNum.current + 1
      console.log(_slug)
      const { data, count } = await api.getFullByBlock(accessToken, _slug, {
        page_num: pageNum.current,
        page_size: 24
      })
      maxCount.current = count
      setRows([...rows, ...data])
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        const timestamp = Date.now()
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
    } catch (error) {
      console.log(error.response)
    } finally {
      setLoading(false)
      calling = false
    }
  }

  useEffect(() => {
    if (loading && maxCount.current > rows.length) fetchMoreData()
  }, [loading])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = Date.now()
        const lastFetchTime = sessionStorage.getItem("lastFetchTime") || 0
        const timeElapsed = currentTime - lastFetchTime
        if (timeElapsed >= config.TIME_REQUEST_HOME_PAGE) {
          fetchData()
          // fetchMoreData()
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [lastFetchTime])

  return (
    <>
      {_video.type_block === TypeEvent.LIVE && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <div>{type === 0 && <CardLive {...item} display_type={_video.display_type} />}</div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.LIVESHOW && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <div>
                      <CardLiveShow {...item} display_type={_video.display_type} />
                    </div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.VOD && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id } = item
                return (
                  <Fragment key={id}>
                    <div>
                      <CardVod {...item} display_type={_video.display_type} showTime={false} />
                    </div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.BANNER && (
        <div>
          <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
            <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
              {_video.name}
            </h2>
            <div className={getClass(_video.type_block, _video.display_type)}>
              {rows?.length > 0 &&
                rows?.map((item) => {
                  const { id, type } = item
                  return (
                    <Fragment key={id}>
                      <div>
                        <CardBanner {...item} display_type={_video.display_type} showTime={false} />
                      </div>
                    </Fragment>
                  )
                })}
            </div>
          </section>
        </div>
      )}
      {_video.type_block === TypeEvent.CATEGORY && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <CardCategory {...item} display_type={_video.display_type} showTime={false} />
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.STORY && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <div>
                      <CardStory {...item} display_type={_video.display_type} showTime={false} />
                    </div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.CHANNEL && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <div>
                      <CardChannel {...item} display_type={_video.display_type} showTime={false} />
                    </div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
      {_video.type_block === TypeEvent.SHORT && (
        <section className="py-12 max-w-screen-xl mx-auto px-4 lg:px-12 2xl:px-0">
          <h2 className="relative uppercase mb-4 text-sm md:text-lg lg:text-xl font-bold text-dark-100">
            {_video.name}
          </h2>
          <div className={getClass(_video.type_block, _video.display_type)}>
            {rows?.length > 0 &&
              rows?.map((item) => {
                console.log(item)
                const { id, type } = item
                return (
                  <Fragment key={id}>
                    <div className="aspect-[9/16]">
                      <CardShort {...item} display_type={_video.display_type} showTime={false} />
                    </div>
                  </Fragment>
                )
              })}
          </div>
        </section>
      )}
    </>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps({ req, query, res }) {
  let pageProps = {
    lists: [],
    slug: "",
    video: {}
  }
  try {
    pageProps = await getPropsSlugPage(req, query, res)
  } catch (error) {
    console.log(error)
  }
  return { props: pageProps }
}
